import { Box, TagColor } from '@factorialco/deprecated-design-system'
import groupBy from 'lodash/groupBy'

import type { TabType } from 'modules/core/components/Table'
import { Tabs } from 'modules/core/components/Table'
import type { WithMultiSelectStateChildrenProps } from 'modules/core/components/WithMultiSelectState'
import i18n from 'modules/core/lib/i18n'

import ImportButton from '../../ImportButton'
import type { ImportedContract } from '../Content/types'
import ContractsTable from '../ContractsTable'

type WithMultiSelectProps = WithMultiSelectStateChildrenProps<ImportedContract>

interface Props {
  contracts: ImportedContract[]
  selected: ImportedContract[]
  attributes: string[]
  customFields: string[]
  onToggleSelectedItem: WithMultiSelectProps['onToggleSelectedItem']
  onDeselectAll: () => void
  onSelectAll: () => void
  toggleModal: () => void
}

const TableTabs = ({
  contracts,
  selected,
  attributes,
  customFields,
  onToggleSelectedItem,
  onDeselectAll,
  onSelectAll,
  toggleModal,
}: Props) => {
  const contractStatus = (contract: ImportedContract): string => {
    return contract.status
  }

  const contractsByStatus = {
    ready: [],
    errored: [],
    // This happens because `status` is defined as a `string` on
    // `ImportedContract` if it defined the values it can have we could just
    // let flow do its magic here because it would know in advance the values
    // of the keys it would be able to generate.
    //
    ...groupBy(contracts, contractStatus),
  }

  const erroredTooltip = i18n.t('import.tabs.tooltips.errored', {
    count: contractsByStatus.errored.length,
  })

  const tabs: Array<TabType<'ready' | 'errored'>> = [
    {
      id: 'ready',
      counter: contractsByStatus.ready.length,
      label: i18n.t('import.tabs.ready'),
      color: TagColor.viridian,
      tooltipColor: 'brand',
    },
    {
      id: 'errored',
      counter: contractsByStatus.errored.length,
      label: i18n.t('import.tabs.errored'),
      tooltip: contractsByStatus.errored.length ? erroredTooltip : '',
      color: TagColor.wrong,
      tooltipColor: 'wrong',
    },
  ]

  return (
    <Box style={{ position: 'relative' }}>
      <div style={{ position: 'absolute', right: '0px' }}>
        <ImportButton selectedContracts={selected} onClickImport={toggleModal} />
      </div>
      <Tabs tabs={tabs}>
        {({ tab, isSelected }) => (
          <Tabs.Panel tab={tab} isSelected={isSelected} key={tab.id}>
            <ContractsTable
              tabId={tab.id}
              contracts={contractsByStatus[tab.id]}
              selected={selected}
              attributes={attributes}
              customFields={customFields}
              onToggleSelectedItem={onToggleSelectedItem}
              onSelectAll={onSelectAll}
              onDeselectAll={onDeselectAll}
            />
          </Tabs.Panel>
        )}
      </Tabs>
    </Box>
  )
}

export default TableTabs
